import { initializeApp } from 'firebase/app'
import { getMessaging, Messaging } from 'firebase/messaging'

// Firebase web app configuration
// These values should be replaced with your actual Firebase configuration
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase app
const app = initializeApp(firebaseConfig)

// Lazy-load messaging instance to avoid errors in unsupported browsers
let messagingInstance: Messaging | null = null

/**
 * Get the messaging instance. This should only be called after checking isSupported()
 * @returns Messaging instance or null if not supported
 */
export const getMessagingInstance = (): Messaging | null => {
  try {
    if (!messagingInstance) {
      messagingInstance = getMessaging(app)
    }
    return messagingInstance
  } catch (error) {
    console.warn('Failed to initialize Firebase Messaging:', error)
    return null
  }
}

export default app
